import { render, staticRenderFns } from "./NormalActivity.vue?vue&type=template&id=465fb72f&"
import script from "./NormalActivity.vue?vue&type=script&lang=js&"
export * from "./NormalActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports